import React from "react";
import { CiLock } from "react-icons/ci";

const ModalMessage = (props) => {

  return (
    <>
      <form>
        <div className="row">
          <div className="col-md-12 mb-3">
            <div className="card text-center">
              
              <div className="card-body bg-danger">
                <div className="row m-1">
                  <div className="col-lg-12 text-white">
                    <div className="form-group mt-2 font-weight-bold">
                     
                      ACCESS DENIED
                      
                    </div>
                    <div className="form-group mt-2">
                     
                     
                      <CiLock style={{ fontSize: "12em" }}/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};
export default ModalMessage;
